<div style="width: 100%;">
  <mat-card class="box">
      <div class="divtitle">
        <span class="flex-container" style="padding: 8px;">
          <h1 class="label">{{'projects.label' |transloco}}</h1>
          <button mat-raised-button color="primary" *ngIf="storageService.roleId<3" routerLink="/project" >{{'projects.new' |transloco}}</button>
        </span>
      </div>
  </mat-card>
</div>

<div style="width: 100%;">
  <mat-card class="box">
    <div>
      <div class="formBox">
        <form method="post" class="wrapper" >
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="id">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >ID.</th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'projects.label' |transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- zone Column -->
            <ng-container matColumnDef="zone_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'projects.zones' |transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.zone_name}} </td>
            </ng-container>

            <!-- start_date Column -->
            <ng-container matColumnDef="start_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'projects.date' |transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.start_date | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <!-- country Column -->
            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'projects.country' |transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.country}} </td>
            </ng-container>

            <!-- company_id Column -->
            <ng-container matColumnDef="company_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'projects.company' |transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.company_id}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let j =index;"
            (click)="onRowClicked(row); $event.stopPropagation()" tabindex="0" (keydown.enter)="onRowClicked(row)"
            [ngClass]="{'row1':j%2 === 0 , 'row2':j%2 != 0 }"> </tr>

          </table>
          <div class="divPag">
            <mat-paginator [pageSizeOptions]="[9, 10, 20, 50]"
                            showFirstLastButtons
                            aria-label="Select page">
            </mat-paginator>
          </div>
        </form>
      </div>

  </div>
  </mat-card>
</div>

<div>
  <mat-card *ngIf="isLoading" class="center-loading">
    <mat-card-content style="margin: 20%;" >
      <mat-progress-spinner style="margin: 0 auto;" color="primary" mode='indeterminate'value='50'></mat-progress-spinner>
    </mat-card-content>
  </mat-card>
</div>
